import { render, staticRenderFns } from "./SettingsIndexesXmlFeed.vue?vue&type=template&id=0247af03&"
import script from "./SettingsIndexesXmlFeed.vue?vue&type=script&lang=js&"
export * from "./SettingsIndexesXmlFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports